import { useState, useEffect } from "react";
import { X } from "lucide-react";

const IosInstallPrompt = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone = (window.navigator as any).standalone === true;
    const dismissed = localStorage.getItem("ios_prompt_dismissed");
    if (isIos && !isStandalone && !dismissed) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="mx-4 mt-2 flex items-start gap-3 rounded-card bg-card p-4 shadow-card">
      <span className="text-xl shrink-0">📲</span>
      <p className="flex-1 text-xs text-muted-foreground leading-relaxed">
        For the best experience and notifications, add Kindred to your home screen. Tap the share button then "Add to Home Screen".
      </p>
      <button
        onClick={() => { setShow(false); localStorage.setItem("ios_prompt_dismissed", "1"); }}
        className="shrink-0 text-muted-foreground"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default IosInstallPrompt;
